<template>
    <div style="margin-top: 40px;" class="indicator-section pt-5">
        <div class="d-flex justify-space-between flex-md-row pb-5 flex-column">
            <div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>
                            <strong class="ml-6" v-html="$t('home.indicators.quotations.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.quotations.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.quotations.sufix')"></div>
                    </div>
                </div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>

                            <strong class="ml-6" v-html="$t('home.indicators.media_plans.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.media_plans.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.media_plans.sufix')"></div>
                    </div>
                </div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>
                            <strong class="ml-6" v-html="$t('home.indicators.campaigns.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.campaigns.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.campaigns.sufix')"></div>
                    </div>
                </div>
            </div>
            <div>
                <!-- <iframe src="https://embed.lottiefiles.com/animation/120644" height="400" width="100%" frameBorder="0"></iframe> -->
                <v-img width="100%" src="@/assets/media-vendors.svg" alt="Media Vendors" max-width="100%"
                    contain></v-img>
            </div>
            <div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>
                            <strong class="ml-6" v-html="$t('home.indicators.visitors.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.visitors.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.visitors.sufix')"></div>
                    </div>
                </div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>
                            <strong class="ml-6" v-html="$t('home.indicators.advertisers.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.advertisers.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.advertisers.sufix')"></div>
                    </div>
                </div>
                <div class="d-flex align-content-center mb-12 --indicator-box">
                    <div>
                        <div class="text-h5 text-md-h4 d-flex align-center">
                            <FourDots>
                            </FourDots>
                            <strong class="ml-6" v-html="$t('home.indicators.agencies.value')"></strong><small
                                class="ml-2" v-html="$t('home.indicators.agencies.label')"></small>
                        </div>
                        <div class="text-p ml-9 mt-3" v-html="$t('home.indicators.agencies.sufix')"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column justify-center align-center pt-6 pb-3">
            <div class="text-h5 text-center grey--text py-3">
               {{ $t('home.indicators.ctaText') }} </div>
            <v-btn color="primary" x-large class="mx-auto" elevation="0" to="whitelabel">{{ $t('home.indicators.ctaBtn') }} <v-icon small class="ml-12">mdi-arrow-right</v-icon></v-btn>
        </div>
    </div>
</template>
<script>
import FourDots from '../../interface/FourDots.vue';
export default {
    name: "IndicatorSection",
    components: { FourDots }
}
</script>
<style>
.--indicator-box {
    height: 75px;
}
</style>